import "antd/lib/tooltip/style";
import _Tooltip from "antd/lib/tooltip";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import "core-js/modules/es6.function.name.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useState } from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import DownloadDatasetModal from 'components/repository/DownloadDatasetModal';
import fetchAPI from 'utils/http/fetchAPI';
import downloadFromUrl from 'utils/downloadFromUrl';
import pushNotificationMessage from 'utils/pushNotificationMessage';
var DownloadButton = function DownloadButton(_ref) {
  var experiment = _ref.experiment;
  var _useState = useState(false),
    modalOpen = _useState[0],
    setModalOpen = _useState[1];
  var _useState2 = useState(false),
    isDownloading = _useState2[0],
    setIsDownloading = _useState2[1];
  var triggerDownload = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var signedUrl;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setIsDownloading(true);
            _context.next = 4;
            return fetchAPI("/v2/experiments/".concat(experiment.id, "/repositoryExpInputs"));
          case 4:
            signedUrl = _context.sent;
            downloadFromUrl(signedUrl);
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            pushNotificationMessage('error', 'Failed to download dataset. Please try again.', 'repositoryExpInputs');
          case 11:
            _context.prev = 11;
            setIsDownloading(false);
            setModalOpen(false);
            return _context.finish(11);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8, 11, 15]]);
    }));
    return function triggerDownload() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleClick = function handleClick() {
    if (experiment.license === 'CC BY-NC 4.0') {
      setModalOpen(true);
    } else {
      triggerDownload();
    }
  };
  return __jsx(React.Fragment, null, __jsx(_Tooltip, {
    title: "Download"
  }, __jsx(_Button, {
    "aria-label": "Download",
    icon: __jsx(DownloadOutlined, null),
    loading: isDownloading,
    onClick: handleClick
  })), __jsx(DownloadDatasetModal, {
    open: modalOpen,
    onClose: function onClose() {
      return setModalOpen(false);
    },
    onDownload: triggerDownload,
    isDownloading: isDownloading,
    datasetName: experiment.name
  }));
};
export default DownloadButton;